/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { APILoginBody } from '@/ts/api/auth.ts'

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import { usePrefsStore } from '@/stores/prefs.ts'
import { login as apiLogin, logout as apiLogout } from '@/ts/api/auth.ts'
import { Identifier } from '@/ts/entities/base/identifier.ts'
import { User } from '@/ts/entities/user.ts'

const LOGGED_OUT_USER = new User(
  new Identifier(-1),
  'anon',
  'Ano',
  'Nymous',
  ['they', 'them'],
  'ano@nymous.invalid',
  {},
  [],
  [],
  [],
  'leg',
  'al'
)

export const useAuthStore = defineStore('auth', () => {
  const prefs = usePrefsStore()

  const router = useRouter()

  const user = ref(LOGGED_OUT_USER)
  const isAuthenticated = computed(() => user.value.id.valueOf() > 0)

  async function login(credentials: APILoginBody) {
    const res = await apiLogin(credentials) // Error will be propagated upwards.
    user.value = res.authenticatedUser
    prefs.preferences = res.preferences
    await router.push('/')
  }

  async function logout() {
    // TODO: error handling?
    await apiLogout()
    user.value = LOGGED_OUT_USER
    prefs.preferences = null
    await router.push('/')
  }

  return {
    user,
    isAuthenticated,

    login,
    logout,
  }
})
